module.exports = __webpack_public_path__ + "img/product_42.16e4584.webp";